export default __webpack_public_path__ + "static/profile-a8190eb1bf89ac6fdefb63599d22aaec.jpg";